import { render, staticRenderFns } from "./CartWidgetNewEcommerce.vue?vue&type=template&id=5d560de8&scoped=true&"
import script from "./CartWidgetNewEcommerce.vue?vue&type=script&lang=ts&"
export * from "./CartWidgetNewEcommerce.vue?vue&type=script&lang=ts&"
import style0 from "./CartWidgetNewEcommerce.vue?vue&type=style&index=0&id=5d560de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d560de8",
  null
  
)

export default component.exports